"use strict";

import React, { useState, useEffect } from "react";
import { USER_DATA } from "../../utils/constants";
import DashboardScreen from "./Dashboard.screen";
import {
  cancelExecution,
  createPipeline,
  getExecutions,
  reRunExecution,
} from "../../api/executions";
import { getRepositories } from "../../api/repository";
import { toast } from "react-toastify";
import { UserTypes } from "../../interfaces/UserTypes";
import { RepositoryTypes } from "../../interfaces/RepositoryTypes";

export default function DashboardContainer() {
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState<UserTypes>();
  const [repositories, setRepositories] = useState([]);
  const [runs, setRuns] = useState<any>([]);
  const [repositorySelected, setRepositorySelected] =
    useState<RepositoryTypes>();
  const [childKey, setChildKey] = useState(1);
  const [open, setOpen] = React.useState(false);
  const [canceling, setCanceling] = React.useState(false);

  useEffect(() => {
    fetchRepositories();
  }, []);

  const fetchRepositories = async () => {
    const userDataStorage = JSON.parse(localStorage.getItem(USER_DATA) || "{}");
    setUserData(userDataStorage);

    getRepositories(userDataStorage.uid)
      .then((response: any) => {
        setRepositories(response);
        setRepositorySelected(response[0]);
        fetchData(response[0]);
      })
      .catch((error) => {
        setRepositories([]);
        setRepositorySelected(undefined);
      });
  };

  const fetchData = (repository: RepositoryTypes) => {
    if (repository != null) {
      setLoading(true);

      if (userData) {
        getExecutions(
          userData?.githubUser!,
          userData?.githubToken!,
          repository?.repository_name
            ? repository?.repository_name
            : String(repository)
        )
          .then((result: any) => {
            setRuns(result);
            setLoading(false);
          })
          .catch((e) => {
            console.log("errooo: ", e);
            setRuns([]);
          });
      }
    }
  };

  useEffect(() => {
    if (repositorySelected != null) {
      console.log("repositorySelected; ", repositorySelected);
      fetchData(repositorySelected);
    }
  }, [repositorySelected]);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     if (repositorySelected != null) {
  //       setLoading(true);

  //       if (userData) {
  //         await getExecutions(
  //           userData.githubUser!,
  //           userData.githubToken!,
  //           repositorySelected.repository_name
  //         )
  //           .then((result: any) => {
  //             setRuns(result);

  //             console.log(result);

  //             setLoading(false);
  //           })
  //           .catch(() => {
  //             setRuns([]);
  //             setLoading(false);
  //           });
  //       }
  //     }
  //   };

  //   setChildKey((prev) => prev + 1);

  //   if (userData && userData.githubUser && userData.githubToken) {
  //     fetchData();
  //   }

  //   const interval = setInterval(() => {
  //     if (
  //       repositorySelected != null &&
  //       userData &&
  //       userData.githubUser &&
  //       userData.githubToken
  //     ) {
  //       refresh();
  //       console.log("CHAMOU!");
  //     }
  //   }, 10000);

  //   return () => clearInterval(interval);
  // }, [repositorySelected]);

  function handleSubmit() {
    if (userData && repositorySelected) {
      createPipeline(
        String(userData.githubUser ?? ""),
        String(userData.githubToken ?? ""),
        repositorySelected.repository_name,
        repositorySelected.pipeline
      ).then((response) => {
        toast.success(
          "Pipeline criado com sucesso! Aguarde um instante a execução..."
        );
        setOpen(true);
      });
    }
  }

  async function refresh() {
    if (userData && repositorySelected) {
      await getExecutions(
        userData.githubUser!,
        userData.githubToken!,
        repositorySelected.repository_name
      ).then((result: any) => {
        if (
          repositorySelected &&
          runs &&
          (runs[0]?.status != result[0]?.status ||
            result[0]?.status != "completed")
        ) {
          setChildKey((prev) => prev + 1);
          setRuns(result);
          setOpen(false);
        }
      });
    }
  }

  async function cancelRun(cancel_url: string) {
    setCanceling(true);
    if (userData) {
      await cancelExecution(cancel_url, userData.githubToken!).then(() => {
        setCanceling(false);
      });
    }
  }

  async function rerun(rerun_url: string) {
    if (userData) {
      await reRunExecution(rerun_url, userData.githubToken!).then((result) => {
        toast.success(
          "Reexecução iniciada! Aguarde um instante para aparecer..."
        );
        setOpen(true);
      });
    }
  }

  return (
    <DashboardScreen
      key={childKey}
      childKey={childKey}
      loading={loading}
      repositories={repositories}
      repositorySelected={repositorySelected}
      setRepositorySelected={setRepositorySelected}
      runs={runs}
      handleSubmit={handleSubmit}
      refresh={refresh}
      open={open}
      setOpen={setOpen}
      cancelRun={cancelRun}
      canceling={canceling}
      rerun={rerun}
      userData={userData as UserTypes}
    />
  );
}
